import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "../Icons/Icons";

import * as styles from "./LanguageToggle.module.scss";

const defaultLabels = {
	selectLanguage: "Language preference",
};

const LanguageToggle = ({
	altLangPages,
	classNames,
	locale,
	renderLanguageSwitcher,
	variant,
	navigationSwitcher,
	labels: providedLabels,
}) => {
	const labels = { ...defaultLabels, ...providedLabels };
	const localeLanguage = locale?.toLowerCase()?.substring(0, 2) || "en";
	const [language, setLanguage] = useState(localeLanguage);
	let toggleComponent = null;

	if (variant === "drop-down") {
		const handleChange = e => {
			const { path } = e.target.options[e.target.selectedIndex].dataset;
			setLanguage(e.target.value);
			navigationSwitcher(path, e.target.value);
		};

		toggleComponent = (
			<>
				<select
					className={cx(classNames?.currentLanguage, styles.currentLanguage, styles.dropDown)}
					onChange={handleChange}
					name="language-selection"
					value={language}
					aria-label={labels.selectLanguage}>
					{altLangPages?.map(({ id, path, lang }) => {
						const optionLanguage = lang?.toLowerCase() === "fr" ? "Français" : "English";

						return (
							<option key={id} data-path={path} value={lang}>
								{optionLanguage}
							</option>
						);
					})}
				</select>
				<Icon name="globe" className={cx(styles.footerLangIcon, styles.dropDown)} />
				<Icon name="chevron-down" className={cx(styles.footerChevron, styles.dropDown)} />
			</>
		);
	} else if (variant === "toggle") {
		toggleComponent = altLangPages?.map(({ id, path, lang }) => {
			if (locale?.toLowerCase()?.substring(0, 2) === lang?.toLowerCase()?.substring(0, 2)) {
				return (
					<>
						<span
							key={id}
							data-id={id}
							className={cx(classNames?.currentLanguage, styles.currentLanguage)}>
							{lang?.toLowerCase() === "fr" ? "Français" : "English"}
						</span>
					</>
				);
			}

			return renderLanguageSwitcher(
				id,
				path,
				lang,
				classNames?.altLanguage,
				lang?.toLowerCase() === "fr" ? "Français" : "English"
			);
		});
	}

	return <div className={cx(styles.container, classNames?.container)}>{toggleComponent}</div>;
};

LanguageToggle.propTypes = {
	altLangPages: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			path: PropTypes.string.isRequired,
			lang: PropTypes.string.isRequired,
		})
	).isRequired,
	classNames: PropTypes.shape({
		container: PropTypes.string,
		currentLanguage: PropTypes.string,
		altLanguage: PropTypes.string,
	}),
	locale: PropTypes.string,
	renderLanguageSwitcher: PropTypes.func,
	variant: PropTypes.oneOf(["drop-down", "toggle"]),
	navigationSwitcher: PropTypes.func,
	labels: PropTypes.shape({
		selectLanguage: PropTypes.string,
	}),
};

LanguageToggle.defaultProps = {
	classNames: undefined,
	locale: "en-CA",
	renderLanguageSwitcher: (id, path, lang, className, label) => (
		<a key={id} className={className} href={path}>
			{label}
		</a>
	),
	variant: "toggle",
	labels: defaultLabels,
	navigationSwitcher: path => {
		window.location.href = path;
	},
};

export { LanguageToggle };
